import { render, staticRenderFns } from "./label-pop.vue?vue&type=template&id=f020f52a&scoped=true&lang=html&"
import script from "./label-pop.vue?vue&type=script&lang=js&"
export * from "./label-pop.vue?vue&type=script&lang=js&"
import style0 from "./label-pop.vue?vue&type=style&index=0&id=f020f52a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f020f52a",
  null
  
)

export default component.exports